export class DrugsLookup {
    Id: number;
    Title: string;
    ForeignTitle: string;
    ValidHours: number;
    ValidDays: number;
    ValidMonths: number;
    CategoryId: number;

    constructor() {
    }
}